var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRosbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5476 0L9 2.84381V9.28571L30.5476 7.34305V0Z",
    fill: "#E4003A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3098 12.9766C18.7968 12.9766 15.9416 15.1404 15.2337 16.0362V13.4396H9V40.0004H15.1946V30.5532C15.9218 31.4685 18.7573 33.5934 22.2901 33.5934C28.1524 33.5934 31.381 30.4169 31.381 23.2698C31.381 16.1227 28.1568 12.9766 22.3098 12.9766ZM20.0906 28.4478C16.3997 28.4478 15.238 27.1084 15.238 23.2547C15.238 19.4009 16.391 18.0615 20.0906 18.0615C23.7903 18.0615 24.9216 19.3815 24.9216 23.2547C24.9216 27.1279 23.8076 28.4391 20.0906 28.4391V28.4478Z",
    fill: "#00274F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosbank);
export default __webpack_public_path__ + "static/media/rosbank.f6903be8e17d2d6aa7dc1be3aaf0d3ef.svg";
export { ForwardRef as ReactComponent };